import React from 'react';

import { useVenueContext } from 'modules/venue/VenueContext';

import Nps from '../Nps';
import useIsNpsFlagEnabled from '../useIsNpsFlagEnabled';

type VenueNpsProps = {
  manual?: boolean;
  onClose?: () => void;
};

export const VenueNps = ({ manual = false, onClose }: VenueNpsProps) => {
  const venue = useVenueContext();
  const isNpsFlagEnabled = useIsNpsFlagEnabled();

  return isNpsFlagEnabled ? <Nps venue={venue} manual={manual} onClose={onClose} /> : null;
};
